export const isTouchDevice = () => {
    if ("ontouchstart" in window || navigator.maxTouchPoints) {
        return true
    }

    return false
}
